'use strict';

var _taggedTemplateLiteral = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject36() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n          "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n          ", "\n\n          ", "\n        "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  border-color: white;\n  color: white;\n  background: transparent;\n  &:active,\n  &:focus,\n  &:hover {\n    border-color: white;\n    background: transparent;\n    color: white;\n    opacity: 0.5;\n  }\n"]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 7px;\n  width: 110px;\n  img {\n    display: block;\n    width: 100%;\n  }\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n    justify-content: flex-start;\n  "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n    justify-content: flex-start;\n  "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n  margin: 4px 0 13px 0;\n  display: flex;\n  justify-content: center;\n\n  ", "\n\n  ", "\n\n  img {\n    max-width: 240px;\n    max-height: 30px;\n  }\n\n  svg {\n    max-width: 240px;\n    height: 12px;\n  }\n"]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  font-size: 28px !important;\n  color: white;\n  &:not(:last-child) {\n    margin-right: 8px;\n  }\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 14px;\n  "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: bold;\n  margin-bottom: 15px;\n  ", "\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 0;\n    flex-basis: auto;\n    align-items: start;\n  "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 43px;\n  "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 48px !important;\n  "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 48px !important;\n  "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  flex-basis: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n          display: block;\n        "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n        display: flex;\n        margin-right: 30px;\n\n        &:last-child {\n          margin: 0;\n        }\n      "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n        display: flex;\n        margin-right: 30px;\n\n        &:last-child {\n          margin: 0;\n        }\n      "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n          ", "\n\n          ", "\n        "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n          display: block;\n        "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n          display: flex;\n          align-items: center;\n\n          & div {\n            margin: 0 20px 0 0;\n          }"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n          display: flex;\n          align-items: center;\n\n          & div {\n            margin: 0 20px 0 0;\n          }"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n          display: flex;\n          align-items: center;\n\n          & div {\n            margin: 0 20px 0 0;\n          }"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n        ", "\n\n        ", "\n\n        ", "\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    text-align: center;\n    > div {\n      margin-top: 32px;\n    }"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    text-align: center;\n    > div {\n      margin-top: 32px;\n    }"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n\n  ", "\n\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    {\n      padding-bottom: 46px;\n    }"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        position: absolute;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  &.ant-layout-footer {\n    ", ";\n    color: white;\n    width: 100%;\n    bottom: 0;\n    padding: 22px 32px;\n    background: ", ";\n    font-size: 12px;\n    text-align: left;\n    align-items: center;\n    ", "\n  }\n\n  a {\n    color: white;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _antd = require('antd');

var _styled = require('../../styled');

var _Icons = require('../Icons');

var _Icons2 = _interopRequireDefault(_Icons);

var _themes = require('../../constants/themes');

var _themes2 = _interopRequireDefault(_themes);

var _mediaTemplates = require('../../styled/mediaTemplates');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FooterContainer = (0, _styledComponents2.default)(_antd.Layout.Footer)(_templateObject(), function (props) {
  return props.absolute && _styledComponents.css(_templateObject2());
}, function (props) {
  return props.userTheme === _themes2.default.BLACK ? _styled.colors.silver.darker : _styled.colors.gray.dark;
}, _mediaTemplates.media.mobile(_templateObject3()));
var RowContainer = (0, _styledComponents2.default)(_mediaTemplates.Container)(_templateObject4(), _mediaTemplates.media.mobile(_templateObject5()), _mediaTemplates.media.tabletsLow(_templateObject6()));
var ColNetwork = (0, _styledComponents2.default)(_antd.Col)(_templateObject7());
var ColLogo = (0, _styledComponents2.default)(_antd.Col)(_templateObject8(), function (_ref) {
  var spPlatformConfig = _ref.spPlatformConfig;
  return spPlatformConfig ? _styledComponents.css(_templateObject9(), _mediaTemplates.media.tablets(_templateObject10()), _mediaTemplates.media.desktop(_templateObject11()), _mediaTemplates.media.desktopHigh(_templateObject12())) : _styledComponents.css(_templateObject13());
});

var LinkWrapper = _styledComponents2.default.div(_templateObject14(), function (_ref2) {
  var spPlatformConfig = _ref2.spPlatformConfig;
  return spPlatformConfig ? _styledComponents.css(_templateObject15(), _mediaTemplates.media.desktop(_templateObject16()), _mediaTemplates.media.desktopHigh(_templateObject17())) : _styledComponents.css(_templateObject18());
});

var ColStaticLinks = (0, _styledComponents2.default)(_antd.Col)(_templateObject19());
var ColSocialMedia = (0, _styledComponents2.default)(_antd.Col)(_templateObject20(), _mediaTemplates.media.mobile(_templateObject21()), _mediaTemplates.media.tabletsLow(_templateObject22()), _mediaTemplates.media.tablets(_templateObject23()), _mediaTemplates.media.allDektops(_templateObject24()));

var ColumnTitle = _styledComponents2.default.div(_templateObject25(), function (props) {
  return props.theme.platformPrimary;
}, _mediaTemplates.media.tabletsLow(_templateObject26()));

var NetworkLinkItem = (0, _styledComponents2.default)(_Icons2.default.Fa)(_templateObject27());

var Logo = _styledComponents2.default.div(_templateObject28(), _mediaTemplates.media.tablets(_templateObject29()), _mediaTemplates.media.allDektops(_templateObject30()));

var GPLink = _styledComponents2.default.a(_templateObject31());

var ContactUsButton = (0, _styledComponents2.default)(_antd.Button)(_templateObject32(), function (_ref3) {
  var spPlatformConfig = _ref3.spPlatformConfig;
  return spPlatformConfig ? _styledComponents.css(_templateObject33(), _mediaTemplates.media.tablets(_templateObject34()), _mediaTemplates.media.allDektops(_templateObject35())) : _styledComponents.css(_templateObject36());
});
exports.default = {
  RowContainer: RowContainer,
  ColNetwork: ColNetwork,
  ColStaticLinks: ColStaticLinks,
  ColSocialMedia: ColSocialMedia,
  FooterContainer: FooterContainer,
  ColumnTitle: ColumnTitle,
  NetworkLinkItem: NetworkLinkItem,
  Logo: Logo,
  GPLink: GPLink,
  ContactUsButton: ContactUsButton,
  ColLogo: ColLogo,
  LinkWrapper: LinkWrapper
};